import React, { useState } from "react";

// --- Individual SVGs as inner components ---
function EyeSVG() {
  return (
    <svg viewBox="0 0 120 120" width={120} height={120}>
      <ellipse cx="60" cy="60" rx="48" ry="36" fill="#fff" stroke="#333" strokeWidth="3" />
      <circle cx="60" cy="60" r="18" fill="#4ba3fa" />
      <circle cx="60" cy="60" r="8" fill="#222" />
      <circle cx="66" cy="54" r="3" fill="#fff" opacity="0.8" />
      <rect
        id="lid"
        x="10"
        y="10"
        width="100"
        height="40"
        rx="20"
        fill="#f7eadb"
        stroke="#f0cda2"
        strokeWidth="2"
      >
        <animate
          attributeName="y"
          values="10;40;10"
          keyTimes="0;0.5;1"
          dur="2.5s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
}
export function EarSVG() {
    return (
      <svg width="90" height="90" viewBox="0 0 90 90">
        <ellipse cx="45" cy="48" rx="20" ry="28" fill="#FFD9B3" stroke="#B97A57" strokeWidth="3"/>
        <path d="M56 51 Q61 60 48 70" stroke="#B97A57" strokeWidth="3" fill="none" />
        <ellipse cx="58" cy="38" rx="6" ry="9" fill="none" stroke="#B97A57" strokeWidth="2" />
      </svg>
    );
  }
  
  export function NoseSVG() {
    return (
      <svg width="70" height="90" viewBox="0 0 70 90">
        <path d="M35 15 Q50 45 33 72 Q31 78 40 78" fill="none" stroke="#C49A6C" strokeWidth="4" />
        <ellipse cx="38" cy="77" rx="2" ry="1.3" fill="#C49A6C" />
        {/* Smell waves */}
        <path d="M46 65 Q50 70 44 75" stroke="#ccc" strokeWidth="2" fill="none">
          <animate attributeName="opacity" values="0;1;0" keyTimes="0;0.5;1" dur="1.2s" repeatCount="indefinite"/>
        </path>
        <path d="M48 69 Q52 74 46 78" stroke="#ccc" strokeWidth="2" fill="none">
          <animate attributeName="opacity" values="0;0.8;0" keyTimes="0;0.6;1" dur="1.8s" repeatCount="indefinite"/>
        </path>
      </svg>
    );
  }
  
  export function TongueSVG() {
    return (
      <svg width="90" height="90" viewBox="0 0 90 90">
        {/* Mouth outline */}
        <ellipse cx="45" cy="60" rx="28" ry="14" fill="#A00" />
        {/* Tongue */}
        <ellipse cx="45" cy="70" rx="18" ry="10" fill="#FF7993" stroke="#B22E4C" strokeWidth="2"/>
        {/* Smile */}
        <path d="M33 62 Q45 80 57 62" stroke="#fff" strokeWidth="3" fill="none"/>
      </svg>
    );
  }
  
function SkinSVG() {
  return (
    <svg viewBox="0 0 120 120" width={120} height={120}>
      <ellipse cx="60" cy="80" rx="22" ry="17" fill="#ffe0bd" stroke="#e0b889" strokeWidth="2" />
      {/* Fingers */}
      <rect x="48" y="40" width="7" height="35" rx="4" fill="#ffe0bd">
        <animateTransform attributeName="transform" type="rotate"
          values="0 51 40;10 51 40;0 51 40;-10 51 40;0 51 40"
          keyTimes="0;0.2;0.5;0.8;1" dur="1.8s" repeatCount="indefinite"
        />
      </rect>
      <rect x="57" y="35" width="6" height="35" rx="4" fill="#ffe0bd" />
      <rect x="65" y="36" width="6" height="33" rx="4" fill="#ffe0bd" />
      <rect x="73" y="40" width="5" height="28" rx="3" fill="#ffe0bd" />
      <rect x="32" y="78" width="17" height="7" rx="4" fill="#ffe0bd" transform="rotate(-25 40 80)">
        <animateTransform attributeName="transform" type="rotate"
          values="-25 40 80;0 40 80;-25 40 80"
          keyTimes="0;0.5;1" dur="1.4s" repeatCount="indefinite"
        />
      </rect>
      {/* Fingernails */}
      <ellipse cx="51" cy="44" rx="3" ry="2" fill="#fff" opacity="0.6" />
      <ellipse cx="60" cy="40" rx="3" ry="2" fill="#fff" opacity="0.6" />
      <ellipse cx="68" cy="42" rx="3" ry="2" fill="#fff" opacity="0.6" />
      <ellipse cx="76" cy="47" rx="2" ry="1.2" fill="#fff" opacity="0.6" />
    </svg>
  );
}

// --- Main Component with cycling logic ---
export default function FiveSensesSVG() {
  const senses = [
    { name: "Eye", label: "Sight", component: EyeSVG },
    { name: "Ear", label: "Hearing", component: EarSVG },
    { name: "Nose", label: "Smell", component: NoseSVG },
    { name: "Tongue", label: "Taste", component: TongueSVG },
    { name: "Skin", label: "Touch", component: SkinSVG }
  ];
  const [index, setIndex] = useState(0);
  const CurrentSVG = senses[index].component;

  return (
    <div style={{ textAlign: "center", marginBottom: 16 }}>
      <h3>{senses[index].label}</h3>
      <CurrentSVG />
      <div style={{ margin: "14px 0" }}>
        <button className="button1" onClick={() => setIndex((index + 1) % senses.length)}>
          See Another
        </button>
      </div>
    </div>
  );
}
